<template>
	<Base class="mb-1">
		<EditCustomer
			v-if="modalCustomer"
			:customerData="{}"
			@closeModal="closeModal('modalCustomer')"
			@newCustomer="setCustomer"
			:name="saleUpsert_customer"
		/>
		<EditProduct
			v-if="modalProduct"
			:productData="{}"
			@closeModal="closeModal('modalProduct')"
			@newProduct="setProduct"
			:showTaxe="possuiPermissao('GER_V_TRIBUTO')"
			:name="saleUpsert_product"
		/>
		<EditAccount
			v-if="modalAccount"
			:accountData="{}"
			@closeModal="closeModal('modalAccount')"
			@newAccount="setAccount"
			:name="saleUpsert_account"
		/>
		<EditCategory
			v-if="modalCategory"
			:categoryData="{}"
			@closeModal="closeModal('modalCategory')"
			@newCategory="setCategory"
			:name="saleUpsert_category"
		/>
		<GenericList
			v-if="modalList"
			titleModal="Pesquisar Cliente"
			@closeModal="closeModal('modalList')"
			:colunas="[
				'CPF/CNPJ',
				'Nome',
				'Sobrenome',
				'E-mail',
				'Celular',
				'Telefone'
			]"
			@clickBtnAdd="showCustomer"
		/>
		<section style="margin: -5px 0 10px 0; border-bottom: solid 1px var(--cal-header-color-hover);">
			<div class="filter-wrap mb-2">
				<div
					v-if="possuiPermissao('GER_I_VENDA') || possuiPermissao('GER_U_VENDA')"
					class="filter mr-2 icon-add-transaction add-btn"
					@click="showSale()"
					title="Venda/Serviço"
				>
					<FilePlusIcon/>
				</div>
				<div
					v-if="possuiPermissao('GER_D_VENDA')"
					class="filter mr-2 icon-delete"
					v-bind:class="!itemSelected ? 'filter-disable' : ''"
					@click="confirmaApagar('All')"
					title="Apagar Selecionados"
				>
					<Trash2Icon/>
				</div>
				<div
					class="filter"
					v-bind:class="[showFiltersForm ? 'filter-active' : '']"
					@click="filterDropDownActive"
					title="Alterar Filtros"
				>
					<FilterIcon/>
				</div>
			</div>
		</section>
		<section>
			<Filters
				:showFiltersForm="showFiltersForm"
				:showOptionsfilter="[
					'initial_date',
					'end_date',
					'comments',
					'rapid_filters'
				]"
				@clickSearch="findSales"
				@clickClose="closeFilters"
			/>
		</section>

		<b-modal
			ref="modalSale"
			hide-footer
			:title="titleModalSale"
			size="xl"
			hide-no-focus="true"
			no-close-on-backdrop
			hide-header-close
			hide-header
		>
			<div class="title-modal">
				<div class="title-text-modal">{{ titleModalSale }}</div>
				<div
					class="float-right btn-hover-modal"
					@click="fecharModal('modalSale')"
				>
					<xIcon/>
				</div>
			</div>
			<div class="modal-edicao mb-3 modal-edicao-label mt-6">
				<b-tabs ref="tabs" class="text-parcela h-modal-sale custom-tabs">
					<b-tab title="Cliente" class="p-2 border border-top-none">
						<b-row class="mt-2 mb-0" v-bind:class="isMobile ? 'd-block' : ''">
							<b-col class="text-parcela" v-bind:class="isMobile ? '' : 'pr-0'">
								<span class="label-conta">Data</span>
								<div class="d-flex">
									<datepicker
										name="date"
										class="w-100"
										placeholder=""
										id="data-lancamento"
										input-class="bg-white"
										v-model="saleUpsert_date"
										:format="formatter"
										:language="ptBR"
										:bootstrap-styling="true"
										data-cy="Data"
										:disabled="editing"
									/>
								</div>
							</b-col>
							<b-col class="text-parcela" v-bind:class="isMobile ? 'mt-2' : 'pr-0 pl-1'">
								<span class="label-conta">
									Cliente
								</span>
								<SearchSelect
									:key="'customer'"
									name="customer"
									:options="customer.filter(item => !item.inactive)"
									:visibleSuggestion="visibleSuggestion.customer"
									:isMobile="isMobile"
									:newRecord="newCustomer"
									:clearSelect="clearSelect"
									@changeSelect="changeSelect"
									@handleSuggestion="handleVisibleSuggestion"
									@invalidSearch="validateOptionSearch"
								/>
							</b-col>
							<b-col  class="text-parcela" v-bind:class="isMobile ? 'mt-2' : 'pl-1'">
								<span class="label-conta">CPF/CNPJ</span>
								<b-form-input
									name="identity"
									class="modal-edicao-input"
									v-model="saleUpsert_identity"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('identity')"
									:disabled="dataDisable.customer"
								/>
							</b-col>
						</b-row>
						<b-row v-bind:class="isMobile ? 'd-block' : 'mb-3 mt-0'">
							<b-col class="d-block text-parcela" v-bind:class="isMobile ? 'mt-2' : 'pr-0'">
								<span class="label-conta">Endereço</span>
								<b-form-input
									name="address"
									class="modal-edicao-input"
									v-model="saleUpsert_address"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('address')"
									:disabled="dataDisable.customer"
								/>
							</b-col>
							<b-col class="d-block text-parcela" v-bind:class="isMobile ? 'mt-2' : 'pl-1'">
								<span class="label-conta">Telefone</span>
								<b-form-input
									name="phone"
									class="modal-edicao-input"
									v-model="saleUpsert_phone"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('phone')"
									:disabled="dataDisable.customer"
								/>
							</b-col>
						</b-row>
						<b-row class="mt-2">
							<b-col class="d-block text-parcela">
								<span class="label-conta">Observações</span>
								<b-form-input
									name="comments"
									class="modal-edicao-input"
									v-model="saleUpsert_comments"
									autocomplete="off"
									placeholder=""
									v-validate="'maxLength:255'"
									:state="validateState('comments')"
								/>
							</b-col>
						</b-row>
					</b-tab>
					<b-tab title="Produtos/Serviços" class="p-2 border border-top-none">
						<b-row class="mt-2">
							<b-col :cols="colsSale[0]"
								class="text-parcela"
								v-bind:class="!isMobile ? 'pr-0' : ''"
							>
								<span class="label-conta">
									Produto/Serviço
								</span>
								<SearchSelect
									:key="'product'"
									name="product"
									:options="product.filter(item => !item.inactive)"
									:visibleSuggestion="visibleSuggestion.product"
									:isMobile="isMobile"
									:newRecord="newProduct"
									:clearSelect="clearSelectProduct"
									:validate="false"
									@changeSelect="changeSelect"
									@handleSuggestion="handleVisibleSuggestion"
									@invalidSearch="validateOptionSearch"
								/>
							</b-col>
							<b-col :cols="colsSale[1]"
								class="d-block text-parcela"
								v-bind:class="!isMobile ? 'pl-1 pr-0' : 'pr-0'"
								>
								<span class="label-conta">Quantidade</span>
								<b-form-input
									name="saleUpsert_quantity"
									class="modal-edicao-input number-class"
									v-model="saleUpsert_quantity"
									autocomplete="off"
									placeholder=""
									:disabled="!saleUpsert_idProduct"
									@input="updateValue('saleUpsert_quantity')"
									inputmode="numeric"
								/>
							</b-col>
							<b-col :cols="colsSale[2]"
								class="d-block text-parcela pl-1 pr-0"
							>
								<span class="label-conta">Preço</span>
								<b-form-input
									name="saleUpsert_amount"
									class="modal-edicao-input number-class"
									v-model="saleUpsert_amount"
									autocomplete="off"
									placeholder=""
									:disabled="!saleUpsert_idProduct"
									@input="updateValue('saleUpsert_amount')"
									inputmode="numeric"
								/>
							</b-col>
							<b-col :cols="colsSale[3]"
								class="d-block text-parcela pl-1 pr-0 mr-0"
							>
								<span class="label-conta">Total</span>
								<section class="d-flex input-value">
									<b-form-input
										name="total"
										class="modal-edicao-input number-class"
										v-model="saleUpsert_total"
										autocomplete="off"
										placeholder=""
										:disabled="true"
										@input="updateValue('saleUpsert_total')"
										inputmode="numeric"
									/>
									<b-button
										class="btn-pay btn-pay-add"
										@click="addProduct(saleUpsert_idProduct)"
										:disabled="invalidProduct"
									>
										+
									</b-button>
								</section>
							</b-col>
						</b-row>
						<section
							v-if="selectedProducts.length"
							class="table-parcelas mt-2"
						>
							<b-row
								v-for="i in selectedProducts.length" :key="i"
								class="mt-1 mb-1 mr-0 justify-items"
							>
								<b-col :cols="colsSale[0]"
									class="d-flex label-parcela-table pl-1 pr-0"
									v-bind:class="!isMobile ? '' : 'mb-2'"
								>
									<span style="width: 2rem; text-align: left;" class="mr-1">{{ i }}</span>
									<b-form-input
										class="modal-edicao-input"
										:disabled="!selectedProducts[i - 1].eventual"
										v-model="selectedProducts[i - 1].description"
										autocomplete="off"
										placeholder=""
									/>
								</b-col>
								<b-col :cols="colsSale[1]"
									class="d-flex label-parcela-table pr-0"
									v-bind:class="!isMobile ? 'pl-1' : 'pl-0'"
								>
									<b-form-input
										:name="`selectedProducts-${i}-quantity`"
										class="modal-edicao-input number-class"
										v-model="selectedProducts[i - 1].quantity"
										autocomplete="off"
										placeholder=""
										inputmode="numeric"
										:disabled="true"
									/>
								</b-col>
								<b-col :cols="colsSale[2]"
									class="d-flex label-parcela-table pl-1 pr-0"
								>
									<b-form-input
										:name="`selectedProducts-${i}-amount`"
										class="modal-edicao-input number-class"
										v-model="selectedProducts[i - 1].amount"
										autocomplete="off"
										placeholder=""
										inputmode="numeric"
										:disabled="true"
									/>
								</b-col>
								<b-col :cols="colsSale[3]"
									class="d-flex label-parcela-table pl-1"
									v-bind:class="!isMobile ? '' : 'pr-0'"
								>
									<b-form-input
										:name="`selectedProducts-${i}-total`"
										class="modal-edicao-input number-class"
										v-model="selectedProducts[i - 1].total"
										autocomplete="off"
										placeholder=""
										inputmode="numeric"
										:disabled="true"
									/>
									<div
										class="btn-pay btn-pay-del"
										title="Apagar"
										@click="delProduct(i - 1)"
									>
										<Trash2Icon size="24" alt="Apagar"/>
									</div>
								</b-col>
							</b-row>
						</section>
					</b-tab>
					<b-tab title="Pagamento" class="p-2 border border-top-none">
						<section class="modal-edicao mb-3 modal-edicao-label">
							<b-row v-bind:class="isMobile ? 'd-block' : ''">
								<b-col class="text-parcela" v-bind:class="isMobile ? 'mb-2' : ''">
									<span class="label-conta">
										Carteira
									</span>
									<SearchSelect
										:key="'account'"
										name="account"
										:options="account.filter(item => !item.inactive && item.permitePagamento)"
										:visibleSuggestion="visibleSuggestion.account"
										:isMobile="isMobile"
										:newRecord="newAccount"
										:clearSelect="clearSelect"
										:validate="validateSearchSelectProduct || receivedAndInstallments.receiveAmount > 0"
										@changeSelect="changeSelect"
										@handleSuggestion="handleVisibleSuggestion"
										@invalidSearch="validateOptionSearch"
									/>
								</b-col>
								<b-col class="text-parcela"  v-bind:class="isMobile ? 'mb-2' : ''">
									<span class="label-conta">
										Categoria da Transação
									</span>
									<SearchSelect
										:key="'category'"
										name="category"
										:options="category.filter(item => !item.inactive)"
										:visibleSuggestion="visibleSuggestion.category"
										:isMobile="isMobile"
										:newRecord="newCategory"
										:clearSelect="clearSelect"
										@changeSelect="changeSelect"
										@handleSuggestion="handleVisibleSuggestion"
										@invalidSearch="validateOptionSearch"
									/>
								</b-col>
								<b-col class="text-parcela"  v-bind:class="isMobile ? 'mb-2' : ''">
									<label class="label-conta">Parcial</label>
									<div style="display: flex !important; align-items: center; margin-top: -4px !important;">
										<div class="toggle-div mr-3">
											<ToggleSwitch
												name="partialReceive"
												class="toggle"
												:value="partialReceive"
												@toggle="_ => subtotal_format !== '0,00' ? changeToggle('partialReceive') : ''"
												:disabled="subtotal_format === '0,00'"
											/>
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row v-bind:class="isMobile ? 'd-block' : ''">
								<b-col class="d-block text-parcela" v-bind:class="isMobile ? 'mb-2' : ''">
									<span class="label-conta">Subtotal</span>
									<b-form-input
										name="subtotal"
										class="modal-edicao-input number-class"
										v-model="subtotal_format"
										:disabled="true"
									/>
								</b-col>
								<b-col class="text-parcela" v-bind:class="isMobile ? 'mb-2' : ''">
									<label class="label-parcela">Desconto</label>
									<b-form-input
										name="desconto"
										class="modal-edicao-input number-class"
										v-model="desconto_format"
										inputmode="numeric"
										@input="numberValidate('desconto')"
										@focus="handleFocus('desconto_format')"
										@blur="handleBlur('desconto_format')"
									/>
								</b-col>
								<b-col class="d-block text-parcela">
									<span class="label-conta" v-bind:class="isMobile ? 'mb-2' : ''">Total</span>
									<b-form-input
										name="grandTotal"
										class="modal-edicao-input number-class"
										v-model="grandTotal_format"
										:disabled="true"
									/>
								</b-col>
							</b-row>
							<b-row v-if="partialReceive" style="width: 100%; margin-left: 0px">
								<Installment
									:editing="editing"
									:date="saleUpsert_date"
									@dataInstallments="setDataInstallments"
									:update="true"
									@errorInstallments="validateInstallments"
									:disableAmount="true"
									:totalAmount="grandTotal"
									:partialReceive="partialReceive"
									:enableValueWithOneInstallment="false"
									:clearFields="clearFields"
									otherValidations=""
								/>
							</b-row>
						</section>
					</b-tab>
				</b-tabs>
			</div>
			<b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="fecharModal('modalSale')">Cancelar</b-button>
			<b-button class="mt-3 float-left btn-modal btn-limpar" @click="limparModal()">Limpar</b-button>
			<b-button
				class="mt-3 ml-1 float-right btn-modal btn-salvar"
				@click="save"
				:disabled="invalidForm || !idCustumerValid || notProductsAdded || errorInstallments || saving"
			>
				Finalizar
			</b-button>
		</b-modal>
		<vue-html2pdf
			:show-layout="false"
			:enable-download="true"
			:preview-modal="false"
			:paginate-elements-by-height="1400"
			:pdf-quality="1"
			pdf-format="A4"
			pdf-orientation="portrait"
			pdf-content-width="1200px"
			:html-to-pdf-options="htmlToPdfOptions"
			ref="html2Pdf"
			:float-layout="floatLayout"
			:manual-pagination="false"
			@hasDownloaded="finishGeneratePdf"
		>
			<section slot="pdf-content" class="pdf-content">
				<ReportPDF
					:title="title"
					:rows="rowsReport"
					:headerData="headerData"
					:fields="fields"
					:config="{
						type: 'document',
						showTitle: true,
						titleDocument: 'Nota'
					}"
					:showLogo="showLogo"
					:showWatermark="showWatermark"
					:isMobile="isMobile"
					:footer="footerReport"
				/>
			</section>
		</vue-html2pdf>
		<b-modal
			ref="modalDetailsSale"
			hide-footer
			:hide-header="hideHeaderModal"
			title="Detalhes da nota"
			size="lg"
			no-overflow
			hide-no-focus
			no-close-on-backdrop
			hide-header-close
		>
			<div>
				<div v-if="hideHeaderModal" class="title-modal" style="top: 1Rem">
					<div class="title-text-modal">Detalhes da nota</div>
					<div
						class="float-right btn-hover-modal"
						@click="fecharModal('modalDetailsSale')"
					>
						<xIcon/>
					</div>
				</div>
				<div class="mt-5 mb-1" style="margin-left: -20px;">
					<div class="container-head">
						<div
							v-if="possuiPermissao('GER_I_VENDA') || possuiPermissao('GER_U_VENDA')"
						>
							<b-col class="container-btn-print" cols="1">
								<b-dropdown no-caret left variant="link" title="Imprimir">
									<template #button-content>
										<printer-icon class="icon-print filter"/>
									</template>
									<b-dropdown-item @click="exportDataSale('csv')">CSV</b-dropdown-item>
									<b-dropdown-item @click="exportDataSale('xlsx')">EXCEL</b-dropdown-item>
									<b-dropdown-item @click="exportDataSale('pdf')">PDF</b-dropdown-item>
								</b-dropdown>
							</b-col>
						</div>
					</div>
				</div>
				<div v-if="loading || linhas.length" class="table-responsive">
					<div class="d-flex float-right">
						<span class="mr-2">Data:</span>
						<span>{{ dataSaleSelected.dateFormated  || '-' }}</span>
					</div>
					<br>
					<div class="d-flex float-right">
						<span class="mr-2">Nota:</span>
						<span >{{ dataSaleSelected.numDoc || '-' }}</span>
					</div>
					<div class="d-flex">
						<span class="ml-2 mr-2"><b>Cliente:</b></span>
						<span class="mr-3">{{ dataSaleSelected.nameCustomer || '-' }}</span>
					</div>
					<DataTable
						class="data-table"
						:loading="loading"
						:colunas="detailsSaleCols"
						:linhas="detailsSaleLines"
						:errMsg="errMsg"
						:nosearch="true"
						:nofilters="true"
						name="detailsAccount"
						:hasPagination="true"
						:noedit="true"
						:acoes="false"
						:selectItem="false"
						:alignColumns="detailsAlignCols"
						scroll
						:sortable="false"
						:state="{
							sortBy: sortTable.sortBy,
							sortAsc: 0,
							query: ''
						}"
						:async="true"
					/>
					<div class="d-flex float-right">
						<h4 class="mr-5">Total:</h4>
						<h4 class="mr-3">{{ numberFormatted(dataSaleSelected.grandTotal || 0) }}</h4>
					</div>
					<br>
					<br>
					<div class="d-flex pt-2 pb-2" style="border-top: 1px solid gray; border-bottom: 1px solid gray">
						<span class="ml-2 mr-2"><b>Observações:</b></span>
						<span class="mr-3">{{ dataSaleSelected.comments || "" }}</span>
					</div>
					<div
						v-if="dataSaleSelected.saleTaxes && Object.keys(dataSaleSelected.saleTaxes).length > 0"
						class="mt-2 text-parcela number-class pt-2"
					>
						<span>Tributos: |</span>
						<span v-for="(value, key) in dataSaleSelected.saleTaxes" :key="key">
						{{ key }}: {{ numberFormatted(value) }} |
						</span>
					</div>
					<div
						v-if="(dataSaleSelected.toReceiveDocument
							&& dataSaleSelected.toReceiveDocument.toReceive
							&& dataSaleSelected.toReceiveDocument.toReceive.length > 1)
							|| (dataSaleSelected.toReceiveDocument
							&& dataSaleSelected.toReceiveDocument.toReceive
							&& dataSaleSelected.toReceiveDocument.toReceive[0].status === 'ACTIVE')"
					>
						<div class="mt-3" style="width: 100%; text-align: center; border: 1px solid #383838">
							<span><b>Convênio de pagamento</b></span>
						</div>
						<table class="installment-table">
							<thead>
								<tr>
									<th>Parcela</th>
									<th>Vencimento</th>
									<th>Valor</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(inst, index) in dataSaleSelected.toReceiveDocument.toReceive" :key="inst.idToReceive"
								>
									<td>{{ index + 1 }}</td>
									<td>{{ formatterSimple(inst.toReceiveDate) }}</td>
									<td class="pr-1" style="text-align: right;">{{ inst.amount }}</td>
									<td>{{ STATUS_RECEIVE[inst.status] }}</td>

								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div v-else class="alert alert-warning" role="alert">
					Erro ao obter informações
				</div>
			</div>
		</b-modal>
		<div v-if="linhas.length && !showPaginationOnlyFooter" class="head-row mb-2 width-pagination-items mt-1">
			<div class="text-head-row width-pagination">
				<label class="text-head-row ml-0">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
				<b-pagination
					class="mr-0 mb-2 ml-3"
					id="page"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</div>
			<b-form
				class="text-head-row width-pagination">
				<label class="text-head-row ml-0 w-60">
					Itens por página
				</label>
				<b-form-select
					class="mr-0 mb-2"
					v-model="pagination.limit.value"
					name="itens-por-pagina"
					:options="optionsItensPorPag"
					@input="changeItensByPage()"
					:disabled="loading"
				/>
			</b-form>
		</div>
		<div class="table-responsive">
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nosearch="false"
				:nofilters="true"
				name="transacoes"
				:hasPagination="true"
				:noedit="true"
				:acoes="false"
				:permissaoEdit="possuiPermissao('GER_U_VENDA')"
				:permissaoDelete="possuiPermissao('GER_D_VENDA')"
				@clickDelete="confirmaApagar"
				@clickEdit="showSale"
				:selectItem="false"
				:alignColumns="alignColumnsTable"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				@clickCheck="showButonsTop"
				@clickDetails="showDetailsSale"
				:details="true"
				@state-change="(state) => newSearch(state)"
				:hideBtnAdd="true"
				@alterInputSearch="(v) => sortTable.query = v"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="false"
				:permissaoEdit="possuiPermissao('GER_U_VENDA')"
				:permissaoDelete="possuiPermissao('GER_D_VENDA')"
				@clickDelete="confirmaApagar"
				@clickEdit="showSale"
				:selectItem="false"
				:globalAcoes="false"
				@clickCheck="showButonsTop"
				:colsDataCard="colsDataCard"
				:details="true"
				@clickDetails="showDetailsSale"
				:showSelectItem="false"
				:nosearch="false"
				@state-change="(state) => newSearch(state)"
				:hideBtnAdd="true"
				@alterInputSearch="(v) => sortTable.query = v"
			/>
		</div>
		<div v-if="linhas.length && showPaginationOnlyFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
	</Base>
</template>

<script>
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";

	import Base from "@/templates/Base.vue";
	import DataTable from "@/components/DataTable";
	import { numberFormatted, stringToNumber, stringToDateUTC, validateNumber, formatterSimple, exportCSVFile, stringToNumberToFixed, isNullValue } from "@/helpers/common";
	import { possuiPermissao } from "../../helpers/permissions";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { SaleService } from "../../services/sale";
	import CardTransaction from "@/components/CardTransaction.vue";

	import * as XLSX from "xlsx";
	import VueHtml2pdf from "vue-html2pdf";
	import ReportPDF from "../Reports/ReportPDF.vue";
	import "./styles.css";
	import Installment from "@/components/Installment.vue";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import { STATUS_RECEIVE } from "@/helpers/enums";
	import Filters from "@/components/Transactions/Filters.vue";
	import { mapState } from "vuex";
	import emitter from "@/eventBus.js";
	import EditCustomer from "../Customer/EditCustomer.vue";
	import EditProduct from "../Product/EditProduct.vue";
	import EditAccount from "../Account/EditAccount.vue";
	import EditCategory from "../CategoryExpenses/EditCategoryExpenses.vue";
	import GenericList from "@/components/GenericList.vue";
	import SearchSelect from "@/components/SearchSelect.vue";

	export default {
		components: {
			Base,
			DataTable,
			Datepicker,
			CardTransaction,
			VueHtml2pdf,
			ReportPDF,
			Installment,
			ToggleSwitch,
			Filters,
			EditCustomer,
			EditProduct,
			GenericList,
			SearchSelect
		},

		inject: ["parentValidator"],

		data () {
			return {
				saleService: new SaleService(),
				possuiPermissao,
				numberFormatted,
				STATUS_RECEIVE,
				formatterSimple,

				ready: true,
				loading: false,
				updating: false,
				ptBR,
				selectCustomer: [],
				sortTable: {
					sortBy: 2,
					order: -1,
					query: ""
				},
				itemSelected: false,
				isMobile: false,

				// filters
				// customer: "",
				inicio: null,
				fim: null,
				comments: "",
				titleModalSale: "",

				// dados model
				saleUpsert_comments: "",
				saleUpsert_date: new Date(),
				saleUpsert_idCustomer: null,
				saleUpsert_customer: "",
				saleUpsert_identity: "",
				saleUpsert_address: "",
				saleUpsert_phone: "",
				saleUpsert_customer_evetual: false,

				saleUpsert_category: "",
				saleUpsert_account: "",

				saleUpsert_idProduct: null,
				saleUpsert_product: "",
				saleUpsert_quantity: "1,00",
				saleUpsert_amount: "0,00",
				saleUpsert_total: "0,00",
				saleUpsert_product_eventual: false,
				selectedProducts: [],

				sales: [],
				visibleSuggestion: {
					customer: false,
					product: false,
					account: false,
					category: false
				},
				idCustumerValid: false,
				dataDisable: {
					customer: true,
					product: true
				},
				notProductsAdded: true,
				invalidProduct: true,
				showFiltersForm: false,
				errMsg: "Nenhum resultado encontrado. Verifique os filtros e tente novamente.",
				colunas: [
					"Nota",
					"Cliente",
					"Data",
					"Valor Total",
					"Observações"
				],
				alignColumnsTable: [
					"left",
					"left",
					"left",
					"right",
					"left"
				],
				colsDataCard: {
					0: {
						idx: 0,
						label: "Nota",
						textAlign: "center",
						cols: 2,
						visible: true
					},
					1: {
						idx: 1,
						label: "Cliente",
						textAlign: "left",
						cols: 10,
						visible: true
					},
					2: {
						idx: 2,
						label: "Data",
						textAlign: "center",
						cols: 3,
						visible: true
					},
					3: {
						idx: 3,
						label: "Valor Total",
						textAlign: "right",
						cols: 3,
						visible: true
					},
					4: {
						idx: 4,
						label: "Observações",
						textAlign: "left",
						cols: 6,
						visible: true
					},
					5: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					},
					6: {
						idx: null,
						label: "",
						textAlign: "left",
						cols: 12,
						visible: false
					},
					7: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					}
				},

				detailsSaleLines: [],
				detailsAlignCols: [
					"left",
					"right",
					"right",
					"right"
				],
				detailsSaleCols:  [
					"Produto/Serviço",
					"Qtde.",
					"Preço",
					"Total"
				],

				linhas: [],
				showAddModal: false,
				titleConta: "",
				invalidForm: true,
				editing: false,
				permitePagamento: null,
				selectItem: false,

				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 25
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				hideHeaderModal: true,
				floatLayout: true,
				fields : [],
				headerData: {},
				rowsReport: [],
				dataSaleSelected: {},
				title: "",
				filename: "",
				colsSale: [
					4,
					2,
					3,
					3
				],

				// Condicoes de pagamento
				grandTotal_format: "0,00",
				grandTotal: 0,
				subtotal_format: "0,00",
				subtotal: 0,
				desconto_format: "0,00",
				desconto: 0,

				receivedAndInstallments: {},
				clearFields: false,
				partialReceive: false,
				errorInstallments: false,

				optionAccount: [],
				optionCategory: [],

				saving: false,
				showWatermark: false,
				showLogo: false,
				footerReport: {},
				showPaginationOnlyFooter: true,
				filtersSearch: {},
				modalCustomer: false,
				modalProduct: false,
				modalList: false,
				showBtnAddCustomer: false,

				modalAccount: false,
				modalCategory: false,
				invalidSearch: {
					account: true,
					category: true,
					product: true,
					customer: true
				},
				newCustomer: {},
				newProduct: {},
				newCategory: {},
				newAccount: {},
				clearSelect: false,
				clearSelectProduct: false,
				validateSearchSelectProduct: true
			};
		},

		computed: {
			htmlToPdfOptions () {
				return {
					margin: [10, 0, 0, 0],
					image: {
						type: "jpeg",
						quality: 1
					},
					enableLinks: false,
					filename: `${this.filename}.pdf`,
					html2canvas: {
						scale: 4,
						useCORS: true
					},

					jsPDF: {
						format: "a4",
						orientation: "portrait",
						//floatPrecision: 16,
						unit: "mm"
					}
				};
			},

			...mapState(["account", "category", "customer", "product"])
		},

		watch: {
			currentPage () {
				this.changePage();
			},

			filters () {
				this.linhas = [];
			},

			saleUpsert_idCustomer: "validateCustomer"
		},

		mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			const paramsUser = localStorage.params ? (JSON.parse(localStorage.params)) : {};
			this.showWatermark = Boolean(paramsUser.config && paramsUser.config.showWatermark);
			this.showLogo = Boolean(paramsUser.config && paramsUser.config.showLogo);
			this.footerReport = paramsUser.config.footerDocument || {};
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			finishGeneratePdf () {
				this.loading = false;
			},

			validateCustomer () {
				this.idCustumerValid = Boolean(this.saleUpsert_idCustomer);
			},

			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
				if (this.isMobile) {
					this.colsSale = [
						12,
						3,
						4,
						5
					];
				} else {
					this.colsSale = [
						4,
						2,
						3,
						3
					];
				}
			},

			changeSelect (option, key) {
				const { value, text, fatherComponent } = option;
				if (value) {
					if (fatherComponent === "account") {
						this.saleUpsert_idAccount = value;
						this.saleUpsert_account = text;
					} else if (fatherComponent === "category") {
						this.saleUpsert_idCategory = value;
						this.saleUpsert_category = text;
					} else if (fatherComponent === "customer") {
						this.saleUpsert_idCustomer = value;
						this.saleUpsert_customer = text;

						const customer = this.customer.filter(ele => ele.value === option.value);
						this.saleUpsert_customer = option.text || "";
						this.saleUpsert_phone = customer[0].cellPhone || customer[0].telephone || null;
						this.saleUpsert_address = customer[0].address || null;
						this.saleUpsert_identity = customer[0].identityDocument || null;
						this.saleUpsert_customer_evetual = customer[0].eventual;

					} else {
						this.saleUpsert_idProduct = value;
						this.saleUpsert_product = text;

						const product = this.product.filter(ele => ele.value === option.value);
						this.saleUpsert_product = option.text || "";
						const total = product[0].sale3 || 0;
						this.saleUpsert_quantity = numberFormatted(1);
						this.saleUpsert_amount = numberFormatted(product[0].sale3 || 0);
						this.saleUpsert_total = numberFormatted(total);
						this.invalidProduct = stringToNumber(this.saleUpsert_total) <= 0 || this.saleUpsert_idProduct === null;
						this.saleUpsert_product_eventual = product[0].eventual;
					}
				} else {
					if (fatherComponent === "account") {
						this.saleUpsert_account = text;
						this.showAccount();
					} else if (fatherComponent === "category") {
						this.saleUpsert_category = text;
						this.showCategory();
					} else if (fatherComponent === "customer") {
						this.saleUpsert_customer = text;
						this.showCustomer();
					} else {
						this.saleUpsert_product = text;
						this.showProduct();
					}
				}
				this.dataDisable[key] = true;
				this.visibleSuggestion[key] = false;
			},

			async showSale (item_) {
				let item = {};
				if (item_ && item_.idSale) {
					[ item ] = this.sales.filter(c => c.idSale === item_.idSale);
				}

				const {
					amount,
					comments,
					date,
					idSale,
					idCustomer,
					identityDocument,
					cellPhone,
					telephone,
					address
				} = item;

				if (!idSale) {
					this.titleModalSale = "Venda/Serviço";
					this.editing = false;
				} else {
					this.titleModalSale = "Edição de Venda/Serviço";
					this.editing = true;

					this.saleUpsert_idSale = idSale;
					this.saleUpsert_comments = comments;
					this.saleUpsert_date = stringToDateUTC(date);
					this.saleUpsert_amount = amount;
					this.saleUpsert_idCustomer = idCustomer || null;
					this.saleUpsert_phone = cellPhone || telephone || null;
					this.saleUpsert_address = address || null;
					this.saleUpsert_identity = identityDocument || null;

					this.receivedAndInstallments = {};

				}
				this.invalidForm = true;
				this.$refs.modalSale.show();
			},

			addProduct (idProduct) {
				const priceTotal = stringToNumberToFixed(this.saleUpsert_total);
				this.subtotal = stringToNumberToFixed(numberFormatted(this.subtotal + priceTotal));
				this.subtotal_format = numberFormatted(this.subtotal);
				this.grandTotal = this.subtotal;
				this.grandTotal_format = this.subtotal_format;

				const description = this.saleUpsert_product;
				const quantity = this.saleUpsert_quantity;
				const amount = this.saleUpsert_amount;
				const total = this.saleUpsert_total;
				const eventual = this.saleUpsert_product_eventual;
				this.selectedProducts.push({
					idProduct,
					description,
					quantity,
					amount,
					total,
					eventual
				});
				this.saleUpsert_idProduct = null;
				this.saleUpsert_product = "";
				this.saleUpsert_quantity = numberFormatted(1);
				this.saleUpsert_amount = numberFormatted(0);
				this.saleUpsert_total = numberFormatted(0);
				this.notProductsAdded = !this.selectedProducts.length;
				this.invalidProduct = true;
				this.saleUpsert_product = "";

				this.clearSelectProduct = !this.clearSelectProduct;
			},

			delProduct (index) {
				const priceTotal = stringToNumber(this.selectedProducts[index].total);
				this.subtotal = stringToNumberToFixed(numberFormatted(this.subtotal - priceTotal));
				this.subtotal_format = numberFormatted(this.subtotal);
				this.grandTotal = this.subtotal;
				this.grandTotal_format = this.subtotal_format;

				this.selectedProducts.splice(index, 1);
				this.notProductsAdded = !this.selectedProducts.length;
			},

			async findSales (filtersSelected) {
				if (filtersSelected) {
					this.pagination.page = 1;
				}

				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				if (filtersSelected) {
					this.filtersSearch = {};
					this.filtersSearch = filtersSelected;
				}
				this.filtersSearch.limit = limit || null;
				this.filtersSearch.offset = offset;
				this.filtersSearch.sortTable = sortTable;

				this.loading = true;
				const result = await this.saleService.getSaleByParams(this.filtersSearch) || {};
				this.sales = result.rows;
				this.linhas = result.rows.reduce((acc, c) => [
					...acc,
					{
						idSale: c.idSale,
						selected: false,
						cols: [
							c.numDoc.toString(),
							c.customerDetail?.description || c.nameCustomer,
							formatterSimple(c.date),
							numberFormatted(c.grandTotal),
							c.comments
						]
					}
				], []);

				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
				if (this.showFiltersForm)
					this.showFiltersForm = false;
			},

			async showDetailsSale (item) {
				const { idSale } = item;
				const filters = {
					idSale
				};
				const productsSale = await this.saleService.getProductsSaleByIdSale(filters);
				const saleSelected = this.sales.find(ele => ele.idSale === item.idSale);
				this.filename = `nota_${(saleSelected.nameCustomer.replace(/ /g, "_"))}_${saleSelected.numDoc}`;
				this.dataSaleSelected = saleSelected;
				this.dataSaleSelected.dateFormated = dayjs(this.dataSaleSelected.date).locale("pt-br").format("DD-MM-YYYY");
				const saleTaxes = {};
				this.detailsSaleLines = productsSale.reduce((acc, c) => {
					c.productSaleTaxe.forEach((pst) => {
						const amount = parseFloat(pst.amount);
						saleTaxes[pst.taxe.name] = saleTaxes[pst.taxe.name] ? saleTaxes[pst.taxe.name] + amount : amount;
					});
					acc.push({
						cols: [
							c.productDetails?.description || c.product.description || "-",
							numberFormatted(c.quantity),
							numberFormatted(c.salePrice),
							numberFormatted(c.total)
						]
					});
					return acc;
				}, []);
				this.dataSaleSelected.saleTaxes = saleTaxes;
				this.$refs.modalDetailsSale.show();
			},

			async exportDataSale (type) {
				try {
					const data = this.detailsSaleLines;

					const exportType = {
						pdf: ["description", "quantity", "amount", "total"],
						xlsx: ["Produto", "Quantidade", "Preço", "Total"],
						csv: ["Produto", "Quantidade", "Preço", "Total"]
					};

					this.rowsReport = [];
					data.forEach((rec) => {
						this.rowsReport.push({
							[exportType[type][0]]: rec.cols[0],
							[exportType[type][1]]: rec.cols[1],
							[exportType[type][2]]: rec.cols[2],
							[exportType[type][3]]: rec.cols[3]
						});
					});

					if (type === "csv") {
						exportCSVFile(this.rowsReport, this.filename);
					} else if (type === "xlsx") {
						const worksheet = XLSX.utils.json_to_sheet(this.rowsReport);
						const workbook = XLSX.utils.book_new();
						XLSX.utils.book_append_sheet(workbook, worksheet, "pagina 1");
						XLSX.writeFile(workbook, `${this.filename}.xlsx`);
					} else {
						// type === "pdf"
						this.floatLayout = false;
						this.fields = [
							{ key: "description", label: "Produto/Serviço" },
							{ key: "quantity", label: "Quantidade", tdClass: "text-right", thClass: "text-right" },
							{ key: "amount", label: "Preço", tdClass: "text-right", thClass: "text-right" },
							{ key: "total", label: "Total", tdClass: "text-right", thClass: "text-right" }
						];

						//this.dataSaleSelected.grandTotal = numberFormatted(this.dataSaleSelected.grandTotal);
						this.headerData = {
							date: dayjs().locale("pt-br").format("DD-MM-YYYY"),
							hour: dayjs().locale("pt-br").format("HH:mm:ss"),
							user: this.userName,
							data: this.dataSaleSelected
						};

						this.$refs.html2Pdf.generatePdf();
						this.floatLayout = true;
					}
				} catch (e) {
					console.log(e);
					this.$swal({
						title: "Erro",
						text: `Falha ao exportar dados! - "${e.message}"`,
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "rgb(132, 170, 194)",
						confirmButtonText: "Ok"
					});
				} finally {

				}
			},

			formatter (date) {
				return dayjs(date).locale("pt-br").format("D [de] MMMM [de] YYYY");
			},

			validateAccount (select) {
				if (this.transferUpsert_idAccountExpense === this.saleUpsert_idAccountIncome)
					if (select === "expense")
						this.transferUpsert_idAccountExpense = null;
					else
						this.saleUpsert_idAccountIncome = null;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findSales();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findSales();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findSales();
			},

			limparModal () {
				this.saleUpsert_idSale = null;
				this.saleUpsert_comments = "";
				this.saleUpsert_date = new Date();
				this.saleUpsert_idCustomer = null;
				this.saleUpsert_customer = "";
				this.saleUpsert_identity = "";
				this.saleUpsert_address = "";
				this.saleUpsert_phone = "";
				this.saleUpsert_idAccount = null;
				this.saleUpsert_idCategory = null;

				this.saleUpsert_idProduct = null;
				this.saleUpsert_product = "";
				this.saleUpsert_quantity = "1,00";
				this.saleUpsert_amount = "0,00";
				this.saleUpsert_total = "0,00";
				this.selectedProducts = [];
				this.notProductsAdded = true;

				this.receivedAndInstallments = {};
				this.grandTotal_format = "0,00";
				this.grandTotal = 0;
				this.subtotal_format = "0,00";
				this.subtotal = 0;
				this.desconto_format = "0,00";
				this.desconto = 0;

				this.clearFields = true;
				this.clearFields = false;
				this.partialReceive = false;

				this.idAccount = null;
				this.idCategory = null;
				this.errorInstallments = false;
				this.saving = false;
				this.invalidForm = true;

				this.clearSelect = !this.clearSelect;
				this.clearSelectProduct = !this.clearSelectProduct;
				this.validateSearchSelectProduct = true;
			},

			fecharModal (modal) {
				this.$refs[modal].hide();
				this.limparModal();
			},


			validateState (ref) {
				const validAccount = !this.partialReceive ? Boolean(this.invalidSearch.account) : Boolean(this.receivedAndInstallments.receiveAmount && this.invalidSearch.account);

				this.invalidForm = hasFieldsWithErrors(this.veeFields) || this.invalidSearch.customer || this.invalidSearch.product || validAccount || this.invalidSearch.category;
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			async save () {
				const payload = {
					idSale: this.saleUpsert_idSale,
					comments: this.saleUpsert_comments,
					date: this.saleUpsert_date,
					idCustomer: this.saleUpsert_idCustomer,
					addedProducts: this.selectedProducts,
					discount: this.desconto.toFixed(2),
					subTotal: this.subtotal.toFixed(2),
					grandTotal: this.grandTotal.toFixed(2),
					idAccount: this.saleUpsert_idAccount,
					idCategory: this.saleUpsert_idCategory,
					dataCustomer: {
						description: this.saleUpsert_customer,
						identity: this.saleUpsert_identity,
						address: this.saleUpsert_address,
						telephone: this.saleUpsert_phone,
						eventual: this.saleUpsert_customer_evetual
					},
					receivedAndInstallments: this.receivedAndInstallments,
					partialReceive: this.partialReceive
				};

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						if (payload.idSale)
							await this.saleService.updateSale({payload});
						else
							await this.saleService.createSale({payload});

						emitter.emit("reloadAccount", { reload: true });
						emitter.emit("reloadProduct", { reload: true });
						this.fecharModal("modalSale");
						this.findSales();

						return {
							title: "Sucesso!",
							body: "Venda efetuada com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar efetuar a venda!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async confirmaApagar (item_) {
				if (typeof (item_) === "string") {
					this.apagarVarios();
					return;
				}

				const [ item ] = this.sales.filter((gu) => gu.idSale === item_.idSale);

				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja deletar a venda?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.apagar(item.idSale);
			},

			async apagar (idSale) {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						const payload = { idsSale: [idSale] };
						await this.saleService.deleteSale({payload});
						this.findSales();

						return {
							title: "Sucesso!",
							body: "Transação deletada com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar a Transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			filterDropDownActive () {
				this.showFiltersForm = !this.showFiltersForm;
			},

			AddDropDownActive () {
				this.showAddModal = !this.showAddModal;
			},

			async apagarVarios () {
				const idsSale = this.linhas.reduce((acc, item) => {
					if (item.selected)
						return [ ...acc, item.idSale ];

					return acc;
				}, []);

				if (!idsSale.length) return;

				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja deletar a transação selecionada?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (!deleteConfirmation)
					return;

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						const payload = { idsSale };
						await this.saleService.deleteSale({payload});
						this.findSales();

						return {
							title: "Sucesso!",
							body: "transação deletada com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar a Transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async updateValue (key) {
				let total = 0;
				if (this.saleUpsert_quantity && this.saleUpsert_amount) {
					total = stringToNumber(this.saleUpsert_quantity) * stringToNumber(this.saleUpsert_amount);
				}
				this.saleUpsert_total = numberFormatted(total);
				this.invalidProduct = total <= 0;

				const value = this[key];
				this[key] = await validateNumber(value);
			},

			showButonsTop () {
				this.itemSelected = this.linhas.some(linha => linha.selected);
			},

			async numberValidate (key) {
				const keyStr = key.concat("_format");

				this[keyStr] = await validateNumber(this[keyStr]);

				if (!this[keyStr] || this[keyStr] == 0)	{
					this[keyStr] = numberFormatted(this[key]);
				} else {
					let keyTmp = this[keyStr].replace(/\./g, "");
					keyTmp = parseFloat(keyTmp.replace(",", "."));

					this[key] = keyTmp;
				}

				if (key === "desconto") {
					this.grandTotal = parseFloat((this.subtotal - this[key]).toFixed(2));
					this.grandTotal_format = numberFormatted(this.grandTotal);
				}
			},

			handleFocus (key) {
				if (isNullValue(this[key])) this[key] = "";
				else if (typeof this[key] === "string") this[key] = this[key].replace(/\./g, "");
			},

			handleBlur (key) {
				if (this[key]) {
					this[key] = numberFormatted(stringToNumber(this[key]));
				}
			},

			setDataInstallments (data) {
				this.receivedAndInstallments = {
					idAccount: this.receiveAccount,
					receiveAmount: data.receivedAmount,
					toReceiveAmount: data.outsa,
					comments: this.receiveExecuteComments,
					sendLatePaymentMessage: data.sendMsg || false,
					toReceiveDataInstallments: data.toReceiveDataInstallments
				};
			},

			changeToggle (key) {
				this[key] = !this[key];
				if (key === "partialReceive") {
					this.validateSearchSelectProduct = !this.validateSearchSelectProduct;
				}
			},

			validateInstallments (valid) {
				this.errorInstallments = valid;
			},

			closeFilters () {
				this.showFiltersForm = false;
			},

			newSearch (state) {
				this.sortTable.query = state.query;
				this.findSales(this.filtersSearch);
			},

			showCustomer () {
				this.modalCustomer = true;
			},

			showProduct () {
				this.modalProduct = true;
			},

			showAccount () {
				this.modalAccount = true;
			},

			showCategory () {
				this.modalCategory = true;
			},

			showList () {
				this.modalList = true;
			},

			closeModal (modal) {
				this[modal] = false;
			},

			setCustomer (newCustomer) {
				this.saleUpsert_customer = newCustomer[0].description;
				this.saleUpsert_idCustomer = newCustomer[0].idCustomer;
				this.saleUpsert_phone = newCustomer[0].cellPhone || newCustomer[0].telephone || null;
				this.saleUpsert_address = newCustomer[0].address || null;
				this.saleUpsert_identity = newCustomer[0].identityDocument || null;
				this.saleUpsert_customer_evetual = newCustomer[0].eventual;
			},

			setProduct (newProduct) {
				this.saleUpsert_product = newProduct[0].description || "";
				this.saleUpsert_idProduct = newProduct[0].idProduct || null;
				const total = newProduct[0].sale3 || 0;
				this.saleUpsert_quantity = numberFormatted(1);
				this.saleUpsert_amount = numberFormatted(newProduct[0].sale3 || 0);
				this.saleUpsert_total = numberFormatted(total);
				this.invalidProduct = stringToNumber(this.saleUpsert_total) <= 0 || this.saleUpsert_idProduct === null;
				this.saleUpsert_product_evetual = newProduct[0].eventual;
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
			},

			handleVisibleSuggestion (handleSuggestion) {
				if (handleSuggestion.visibleSuggestion) {
					const visibleSuggestionKeys = Object.keys(this.visibleSuggestion);
					visibleSuggestionKeys.forEach((vsk) => {
						if (vsk === handleSuggestion.name) {
							this.visibleSuggestion[vsk] = handleSuggestion.visibleSuggestion;
						} else {
							this.visibleSuggestion[vsk] = false;
						}
					});
				} else {
					this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
				}
			}
		}
	};
</script>

<style>
	.input-value {
		width: 100%;
		padding-right: 1rem;
	}

	.pdf-content {
		max-width: 100%; /* Asegura que el contenido no exceda el ancho */
		overflow: hidden; /* Evita que el contenido se desborde */
		word-wrap: break-word; /* Rompe palabras largas */
		transform: scale(0.7); /* Reduce el tamaño del contenido */
		transform-origin: top left;
		height: 28.5cm;
		overflow: hidden;
	}
</style>

<style scoped>
	tbody td {
		border: 1px solid #383838;
		padding-left: 6px
	}

	.installment-table {
		width: 100%;

	}

	table {
		border: 1px solid #383838;
		text-align: left;
	}

	table th {
		border: 1px solid #383838;
		padding-left: 6px
	}

	/* ::v-deep(.custom-tag),
	::v-deep(.custom-tag .nav-link.active) {
		background-color: #d5dde4 !important;
		color: black !important;
	} */

	.custom-tabs >>> .nav-link {
		background-color: #ecf0f3 !important;
		border: 1px solid #ecf0f3  !important;
		color: #575555;
	}

	.custom-tabs >>> .nav-link:hover {
		background-color: #d5dde4 !important;
		border: 1px solid #fff !important;
	}

	.custom-tabs >>> .nav-link.active {
		background-color: #d5dde4 !important;
		border: 1px solid #d5dde4 !important
	}

	.custom-tabs >>> .tab-pane.active {
		background-color: #d5dde4 !important;
		border: 1px solid #d5dde4 !important;
		min-height: 57vh !important;
	}
</style>